module.exports = __webpack_public_path__ + "img/w3_circle_trash_check_dark.ffdf9e4e.png";